<ng-container *ngIf="isDisplayed$() | async">
    <p *ngIf="description">{{ description | loadTemplateData$ | async }}</p>

    <button *ngIf="isButton()" (click)="triggerAction()" mat-raised-button [ngClass]="{inverted: isSecondary()}">
        <mat-icon *ngIf="icon" [svgIcon]="icon"></mat-icon>
        <span>{{ text | loadTemplateData$ | async | translate }}</span>
    </button>

    <a *ngIf="!isButton()" (click)="triggerAction()">
        {{ text | loadTemplateData$ | async | translate }}
    </a>
</ng-container>